import { Observable } from 'rxjs';

import { INotification } from 'domain/notification/notification';

import { RequestMeetingCmd } from '../command/request-meeting.cmd';
import { SendMeetingAlternativeCmd } from '../command/send-meeting-alternative.cmd';

export abstract class NotificationApplicationPort {
	public abstract acceptMeeting(notificationId: string): Observable<string>;

	public abstract fetchNotification(notificationId: string): Observable<string>;

	public abstract observeNotification(
		notificationId: string
	): Observable<INotification>;

	public abstract fetchNotifications(): Observable<string[]>;

	public abstract markNotificationRead(notificationId: string): Observable<void>;

	public abstract observeNotifications(): Observable<INotification[]>;

	public abstract rejectMeeting(notificationId: string): Observable<void>;

	public abstract requestMeeting(cmd: RequestMeetingCmd): Observable<string>;

	public abstract sendMeetingAlternative(
		cmd: SendMeetingAlternativeCmd
	): Observable<string>;

	public abstract cancelMeetingRequest(notificationId: string): Observable<void>;

	public abstract markAllNotificationsRead(): Observable<string[]>;
}
